import React, { useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import {
  MDBContainer,
  MDBCol,
  MDBRow,
  MDBBtn,
  MDBInput,
  MDBCheckbox
} from 'mdb-react-ui-kit';
import CompanyNameModal from '../Modals/CompanyNameModal';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { useMessageBox } from '../Common/MessageBox';

const API_BASE_URL = `${config.API_BASE_URL}/api/auth`;

function Login({ onSwitchToRegister, onLoginSuccess }) {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [googleLoading, setGoogleLoading] = useState(false);
  const { showError, showSuccess, showWarning, MessageBoxComponent } = useMessageBox();

  // Company Name Modal States
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [pendingGoogleUser, setPendingGoogleUser] = useState(null);

  // =====================
  // EMAIL / PASSWORD LOGIN
  // =====================
 const handleLogin = async (e) => {
  e.preventDefault();

  if (!email || !password) {
    showWarning('Email and password are both required');
    return;
  }

  try {
    setLoading(true);

    // 🔥 CHECK KARO CHATBOT SE AAYA HAI YA NHI
    const isFromChatbot = localStorage.getItem('chatbot_source') === 'true';
    
    const payload = { 
      email, 
      password,
      source: isFromChatbot ? 'chatbot' : undefined  // ← YEH ADD KARO
    };

    const res = await fetch(`${API_BASE_URL}/login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload)
    });

    const data = await res.json();

    if (!res.ok) {
      showError(data.message || 'Login failed');
      return;
    }

    // Login success
    login(data.token, data.user);
    
    // 🔥 CLEAR KARO LOCALSTORAGE
    if (isFromChatbot) {
      localStorage.removeItem('chatbot_source');
    }
    
    showSuccess(`Welcome ${data.user.name}!`);
    
    // 🔥 AGAR CHATBOT SE AAYA THA TO WAPIS CHATBOT PE BHEJO
    if (isFromChatbot) {
      window.location.href = "/scout";
    } else {
      onLoginSuccess && onLoginSuccess(data.user);
    }

  } catch (err) {
    console.error('LOGIN ERROR:', err);
    showError('Server error. Please try again.');
  } finally {
    setLoading(false);
  }
};

  // =====================
  // GOOGLE LOGIN - STEP 1: Get User Info
  // =====================
const googleLogin = useGoogleLogin({
  onSuccess: async (tokenResponse) => {
    try {
      setGoogleLoading(true);

      const userInfoResponse = await fetch(
        'https://www.googleapis.com/oauth2/v3/userinfo',
        {
          headers: { Authorization: `Bearer ${tokenResponse.access_token}` },
        }
      );
      const userInfo = await userInfoResponse.json();

      const isFromChatbot = localStorage.getItem('chatbot_source') === 'true';

      // CHECK USER EXISTS
      const checkRes = await fetch(`${API_BASE_URL}/check-google-user`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: userInfo.email }),
      });
      const checkData = await checkRes.json();

      // 🔥🔥🔥 AGAR CHATBOT SE AAYA HAI TO MODAL SKIP KARO 🔥🔥🔥
      if (!checkData.exists && isFromChatbot) {
        // DIRECT BACKEND CALL WITHOUT MODAL
        const backendResponse = await fetch(`${API_BASE_URL}/google-auth`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            token: tokenResponse.access_token,
            email: userInfo.email,
            name: userInfo.name,
            source: 'chatbot',
            company_name: `${userInfo.name}'s Chatbot Account`,
            country: 'US',
            city: 'New York',
            address: 'Chatbot User',
            postal_code: '10001',
            phone_number: '+1234567890'
          }),
        });

        const backendData = await backendResponse.json();
        login(backendData.token, backendData.user);
        localStorage.removeItem('chatbot_source');
        window.location.href = "/scout";
        return;
      }

      // NEW USER (NOT FROM CHATBOT) → SHOW MODAL
      if (!checkData.exists) {
        setPendingGoogleUser({
          token: tokenResponse.access_token,
          userInfo,
          source: undefined
        });
        setShowCompanyModal(true);
        return;
      }

      // EXISTING USER LOGIN
      const backendResponse = await fetch(`${API_BASE_URL}/google-auth`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          token: tokenResponse.access_token,
          email: userInfo.email,
          name: userInfo.name,
          source: isFromChatbot ? 'chatbot' : undefined
        }),
      });

      const backendData = await backendResponse.json();
      login(backendData.token, backendData.user);
      
      if (isFromChatbot) {
        localStorage.removeItem('chatbot_source');
        window.location.href = "/scout";
      } else {
        onLoginSuccess && onLoginSuccess(backendData.user);
      }

    } catch (err) {
      console.error("Google login error:", err);
      showError("Google login failed");
    } finally {
      setGoogleLoading(false);
    }
  },
});


  // =====================
  // GOOGLE LOGIN - STEP 2: Complete Auth with Company Name
  // =====================
 const completeGoogleAuth = async (token, userInfo, formData) => {
  try {
    const backendResponse = await fetch(`${API_BASE_URL}/google-auth`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        token,
        email: userInfo.email,
        name: userInfo.name,
        ...formData,
      }),
    });

    const backendData = await backendResponse.json();

    if (!backendResponse.ok) return null;

    login(backendData.token, backendData.user);
    return backendData; // ✅ IMPORTANT
  } catch (e) {
    return null;
  }
};


  // =====================
  // HANDLE COMPANY NAME SUBMISSION
  // =====================
const handleCompanyNameSubmit = async (formData) => {
  if (!pendingGoogleUser) return;

  const backendData = await completeGoogleAuth(
    pendingGoogleUser.token,
    pendingGoogleUser.userInfo,
    formData
  );

  if (!backendData) return;

  setShowCompanyModal(false);
  setPendingGoogleUser(null);

  onLoginSuccess && onLoginSuccess(backendData.user);
};



  return (
    <>
      <MDBContainer fluid className="p-3" style={{ minHeight: '100vh' }}>
        <MDBRow className="justify-content-center align-items-center" style={{ minHeight: '100vh' }}>

          {/* ============================================ */}
          {/* LEFT: IMAGE SECTION */}
          {/* ============================================ */}
          <MDBCol 
            xs="12" 
            md="6" 
            lg="6"
            className="d-none d-md-flex align-items-center justify-content-center"
            style={{ padding: '2rem' }}
          >
            <div style={{ maxWidth: '100%', width: '100%' }}>
              <img
                src="/images/man_in_brown_coat_shopify_ebay_ad.png"
                className="img-fluid"
                alt="Login"
                style={{ 
                  width: '100%',
                  height: 'auto',
                  objectFit: 'contain',
                  maxHeight: '80vh'
                }}
              />
            </div>
          </MDBCol>

          {/* ============================================ */}
          {/* RIGHT: LOGIN FORM */}
          {/* ============================================ */}
          <MDBCol 
            xs="12" 
            md="6" 
            lg="5" 
            xl="4"
            className="d-flex justify-content-center"
            style={{ padding: '2rem' }}
          >
            <div style={{ width: '100%', maxWidth: '450px' }}>

              {/* LOGO & TITLE */}
              <div className="text-center mb-4">
                <img
                  src="/images/thriftlogo.png"
                  alt="ThriftLogo"
                  style={{ 
                    height: 'clamp(60px, 10vw, 80px)',
                    marginBottom: '1rem',
                    width: 'auto'
                  }}
                />
                <p className="text-muted" style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}>
                  List once, sell everywhere
                </p>
              </div>

              {/* GOOGLE LOGIN BUTTON */}
              <MDBBtn
                className="mb-3 w-100 d-flex align-items-center justify-content-center"
                size="lg"
                style={{
                  backgroundColor: '#fff',
                  color: '#000',
                  border: '1px solid #ddd',
                  padding: 'clamp(0.6rem, 2vw, 0.8rem)',
                  fontSize: 'clamp(0.9rem, 2vw, 1rem)'
                }}
                onClick={() => googleLogin()}
                disabled={googleLoading}
              >
                {googleLoading ? (
                  "Signing in..."
                ) : (
                  <>
                    <img
                      src="/images/google-icon.svg"
                      alt="Google"
                      style={{ 
                        width: 'clamp(18px, 3vw, 22px)', 
                        height: 'clamp(18px, 3vw, 22px)', 
                        marginRight: '10px' 
                      }}
                    />
                    Sign in with Google
                  </>
                )}
              </MDBBtn>

              {/* DIVIDER */}
              <div className="divider d-flex align-items-center my-3">
                <p className="fw-bold mx-3 mb-0" style={{ color: '#888', fontSize: 'clamp(0.8rem, 2vw, 0.9rem)' }}>
                  OR
                </p>
              </div>

              {/* LOGIN FORM */}
              <form onSubmit={handleLogin}>
                
                <MDBInput
                  label="Email address"
                  id="email"
                  type="email"
                  size="lg"
                  className="mb-3"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}
                />

                <MDBInput
                  label="Password"
                  id="password"
                  type="password"
                  size="lg"
                  className="mb-3"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  style={{ fontSize: 'clamp(0.9rem, 2vw, 1rem)' }}
                />

                <div className="d-flex justify-content-between align-items-center mb-3" 
                     style={{ fontSize: 'clamp(0.85rem, 2vw, 0.95rem)' }}>
                  <MDBCheckbox 
                    label="Remember me" 
                    id="rememberMe"
                  />
                  <a href="#!" style={{ textDecoration: 'none' }}>
                    Forgot password?
                  </a>
                </div>

                <MDBBtn
                  type="submit"
                  className="w-100"
                  size="lg"
                  disabled={loading}
                  style={{ 
                    backgroundColor: '#667eea',
                    padding: 'clamp(0.6rem, 2vw, 0.8rem)',
                    fontSize: 'clamp(0.9rem, 2vw, 1rem)'
                  }}
                >
                  {loading ? 'Signing in...' : 'Sign in'}
                </MDBBtn>

              </form>

              {/* REGISTER LINK */}
              <div className="text-center mt-3" style={{ fontSize: 'clamp(0.85rem, 2vw, 0.95rem)' }}>
                <p className="mb-0">
                  Not a member?{' '}
                  <a 
                    href="#!" 
                    onClick={onSwitchToRegister} 
                    style={{ cursor: 'pointer', textDecoration: 'none', fontWeight: '500' }}
                  >
                    Register here
                  </a>
                </p>
              </div>

            </div>
          </MDBCol>

        </MDBRow>
      </MDBContainer>

      {/* ============================================ */}
      {/* COMPANY NAME MODAL */}
      {/* ============================================ */}
      <CompanyNameModal
        show={showCompanyModal}
        userName={pendingGoogleUser?.userInfo?.name || ''}
        onSubmit={handleCompanyNameSubmit}
      />
      <MessageBoxComponent />
    </>
  );
}

export default Login;